import Vue from "vue";
import VueRouter from "vue-router";
import jsonp from "../assets/js/http";
Vue.use(VueRouter);

//1邮乐优鲜App、2邮乐优鲜H5商城、3邮乐优鲜小程序、4邮乐网App、5邮乐H5商城、6邮乐商城小程序
const routes = [
	{
		path: "/",
		redirect: "/broadList",
	},
	{
		path: "/broadList/:source?",
		name: "broadList",
		component: () => import("@/views/broadlist/broadlist.vue"),
		meta: {
			title: "邮乐直播",
		},
	},
	{
		path: "/broadLive/:id/:roomNumber",
		name: "broadLive",
		component: () => import("@/views/broadlive/broadlive.vue"),
	},
	{
		path: "/broadLive/:id/:roomNumber/:source?",
		name: "broadLive",
		component: () => import("@/views/broadlive/broadlive.vue"),
	},
	{
		path: "/broadHost/:id/:roomNumber/:source?",
		name: "broadHost",
		component: () => import("@/views/broadHost/broadHost.vue"),
	},
	{
		path: "/agreement/privacy",
		name: "privacy",
		component: () => import("@/views/agreement/privacy.vue")
	},
	{
		path: "/agreement/service",
		name: "service",
		component: () => import("@/views/agreement/service.vue")
	},
	{
		path: "/insurance/:id",
		name: "insurance",
		component: () => import("@/views/insurance/insurance.vue")
	},
	{
		path: "/insurance/:id/:source?",
		name: "insurance",
		component: () => import("@/views/insurance/insurance.vue")
	},
	// 关注列表
	{
		path: "/attentionList",
		name: "attentionList",
		component: () => import("@/views/attentionList/attentionList.vue")
	},
	//录制视频预览页面
	{
		path: "/filmed/video",
		name: "filmed",
		component: () => import("@/views/filmedVideo/video.vue")
	},
	//app使用的红包雨路由
	{
		path: "/packetRain/:roomNumber/:packetCode/:source?",
		name: "packetRain",
		component: () => import("@/views/packetRain/packetRain.vue"),
		meta: {
			title: "红包雨",
		},
	},
	// 邮储银行联合登录
	{
		path: "/login",
		name: "login",
		component: () => import("@/views/login/login.vue"),
		meta: {
			title: "邮储联合登录",
		},
	},
];

const router = new VueRouter({
	routes,
	mode: "history",
	base: "/broadcast",
});

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}

	if (location.hostname != 'localhost' && (to.query.console || (process.env.NODE_ENV =='beta'))) {
		var script = document.createElement("script");
		script.src = "//lib.baomitu.com/vConsole/3.3.4/vconsole.min.js";
		script.onload = function() {
			new (<any>window).VConsole();
		};
		document.body.appendChild(script);
	}
	
	if(to.params.id){
		const callback = 'track'
		jsonp(`${process.env.VUE_APP_URI_CDNDOMAIN}/live/api/out/room/newBoFangBase/${to.params.id}/${Math.floor(new Date().getTime() / 5000)}/${callback}?t=${new Date().getTime()}`, {
			id: to.params.id,
			jsonp: callback,
			jsonpcallback:callback
		}).then((data: any) => {
			sessionStorage.setItem('new_user_remain',data.new_user_remain) // 新用户是否留存
			let source:any = {
				3:"usq",
				4:"ule",
				5:"uxd",
				1:"uzg",
				6:'ysh',
				7:'ztk',//主题卡直播
				8:'fq',// 分期商城
				9:'ylxdsq'
			};
			Vue.prototype.source = source[data.tvType];
			Vue.prototype.scene_number = data.scene_number || '';
			setTrackPramas(source[data.tvType], data.scene_number+'', data.title);
			next();
		});
	}else{
		setTrackPramas(to.params.source, '', '');
		next();
	}

	function setTrackPramas(type:string, sceneId:string, roomName:string){
		if (/broadLive/.test(location.href)) {
			window._utk_statdata = window._utk_statdata || {};
			window._utk_statdata.relateType = "broadlive";
			window._utk_statdata.relateId1 = to.params.roomNumber;
			window._utk_statdata.relateId2 = type ;//原有source
			window._utk_statdata.relateId3 = sceneId
			window._utk_statdata.relateName = roomName;
			window._utk_statdata.storeId = to.query.storeid || to.query.storeId || "";
			window._utk_statdata.shareId = to.query.shareId || to.query.shareid || "";
		}
	}

});
router.afterEach((to, from) => {
	setTimeout(() => {
		(<any>window).uleStatUtil && (<any>window).uleStatUtil.sendView(location.href);
	}, 200);
});
export default router;